var partial = require('./partial');

    /**
     * Returns the first function passed as an argument to the second,
     * allowing you to adjust arguments, run code before and after, and
     * conditionally execute the original function.
     */
    function wrap(fn, wrapper){
        return partial(wrapper, fn);
    }

    module.exports = wrap;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/wrap.js
// module id = 1597
// module chunks = 0 1 2